import { render } from "./CadastroCaixa.vue?vue&type=template&id=3a115a01"
import script from "./CadastroCaixa.vue?vue&type=script&lang=js"
export * from "./CadastroCaixa.vue?vue&type=script&lang=js"

import "./CadastroCaixa.vue?vue&type=style&index=0&id=3a115a01&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__